import commonService from "@/backend/services/base/commonService.js";
import _ from "lodash";
const simpleFormPageCreate = (params, callback) => {
  let api = params.api,
    type = params.type,
    data = params.data,
    config = params.config || {};

  let transData = function() {
    let transformData = {};
    _.forEach(data, (item, key) => {
      transformData[key] = item.value;
    });
    return (transformData = callback ? callback(transformData) : transformData);
  };
  let submit = async function() {
    let formdata = await commonService({
      api: api,
      type: type,
      body: transData(),
      config: config
    }).querying();

    return formdata;
  };
  return {
    submit: submit
  };
};
export default simpleFormPageCreate;
